import React, { useState, useRef, useEffect } from 'react';
import caitlynHexgatesGif from '../assets/Q12/caitlyn_hexgates.gif';
import reiBlush from '../assets/Q12/rei_blush.jpg';
import viSuprisedGif from '../assets/Q12/vi_jail_surprise.gif';
import reiFlirt from '../assets/Q12/rei_flirt.jpg';
import reiKabedon from '../assets/Q12/rei_ask_rose_lockers.jpg';
import no1 from '../assets/Q12/1_vi_confused.gif';
/* import no2 from '../assets/Q12/2_vi_surprised.gif';
import no3 from '../assets/Q12/3_vi_points_face.gif';
import no4 from '../assets/Q12/4_vi_eyeroll.gif';
import no5 from '../assets/Q12/5_vi_angry_loading.gif'; */
import hansumBird from '../assets/Q12/hansum_bird.jpg';
import hamiltonKingDance from '../assets/Q12/hamilton-king-weird_dance.gif';
import reiSayYes from '../assets/Q12/rei_say_yes.jpg';

const NO_IMGS = [no1, no1, no1, no1, no1];

const STAGES = {
  initial: 'initial',
  wrong_question: 'wrong_question',
  discuss_later: 'discuss_later',
  so_youKnow: 'so_youKnow',
  like_you: 'like_you',
  my_valentine: 'my_valentine'
};

function Q12({ question = 12, totalQuestions = null, onNavigate }) {
  const questionDisplay = totalQuestions != null ? `${question}/${totalQuestions}` : String(question);
  const [stage, setStage] = useState(STAGES.initial);
  const [noImgIndex, setNoImgIndex] = useState(-1);
  const [noValentineOpacity, setNoValentineOpacity] = useState(1);
  const [noValentineHovered, setNoValentineHovered] = useState(false);
  const [noButtonSpinning, setNoButtonSpinning] = useState(false);
  const [noValentineNoIsQuestion, setNoValentineNoIsQuestion] = useState(false);
  const [noButtonFalling, setNoButtonFalling] = useState(false);
  const [hansumBirdJumping, setHansumBirdJumping] = useState(false);
  const [showHamiltonDance, setShowHamiltonDance] = useState(false);
  const [showReiSayYes, setShowReiSayYes] = useState(false);
  const [yesButtonHovered, setYesButtonHovered] = useState(false);
  const [yesValentineScale, setYesValentineScale] = useState(1);
  const hamiltonTimerRef = useRef(null);
  const reiDelayTimerRef = useRef(null);
  const frozenYesScaleRef = useRef(null);

  const displayYesScale = noValentineNoIsQuestion
    ? (frozenYesScaleRef.current ?? (frozenYesScaleRef.current = yesValentineScale))
    : ((frozenYesScaleRef.current = null), yesValentineScale);

  useEffect(() => {
    if (!showHamiltonDance) return;
    const fallDurationMs = 800;
    const extraMs = 1000;
    const reiDelayMs = 500;
    hamiltonTimerRef.current = setTimeout(() => {
      setShowHamiltonDance(false);
      reiDelayTimerRef.current = setTimeout(() => {
        setShowReiSayYes(true);
        reiDelayTimerRef.current = null;
      }, reiDelayMs);
    }, fallDurationMs + extraMs);
    return () => {
      if (hamiltonTimerRef.current) clearTimeout(hamiltonTimerRef.current);
      // Don't clear reiDelayTimerRef here: it's set inside the Hamilton timeout and would be killed when showHamiltonDance becomes false
    };
  }, [showHamiltonDance]);

  useEffect(() => {
    return () => {
      if (reiDelayTimerRef.current) clearTimeout(reiDelayTimerRef.current);
    };
  }, []);

  const greeting =
    stage === STAGES.initial
      ? 'You really think I needed all the guards at the Hexgates?'
      : stage === STAGES.wrong_question
        ? 'Wait, wrong question'
        : stage === STAGES.discuss_later
          ? "We'll discuss this later. For science."
          : stage === STAGES.so_youKnow
            ? "So... you know..."
            : stage === STAGES.like_you
              ? "I like you Mia ❤︎"
              : "Be my Valentine ?";

  const gifSrc = stage === STAGES.wrong_question ? null  
    : stage === STAGES.discuss_later ? viSuprisedGif 
    : stage === STAGES.so_youKnow ? reiBlush 
    : stage === STAGES.like_you
      ? reiFlirt
    : stage === STAGES.my_valentine
      ? noValentineNoIsQuestion
        ? showHamiltonDance
          ? null
          : showReiSayYes
            ? reiSayYes
            : hansumBirdJumping || noButtonFalling
              ? null
              : hansumBird
        : noImgIndex >= 0
          ? NO_IMGS[noImgIndex]
          : reiKabedon
    : caitlynHexgatesGif;

  const handleLeftClick = () => {
    if (stage === STAGES.initial) {
      setStage(STAGES.wrong_question);
    } else if (stage === STAGES.wrong_question) {
      setStage(STAGES.so_youKnow);
    } else if (stage === STAGES.discuss_later) {
      setStage(STAGES.so_youKnow);
    } else if (stage === STAGES.so_youKnow) {
      setStage(STAGES.like_you);
    } else if (stage === STAGES.like_you) {
      setStage(STAGES.my_valentine);
      setNoValentineOpacity(1);
      setNoValentineNoIsQuestion(false);
      setNoButtonFalling(false);
        setHansumBirdJumping(false);
        setShowHamiltonDance(false);
        setShowReiSayYes(false);
      setYesButtonHovered(false);
      setYesValentineScale(1);
    } else {
      onNavigate?.('freakout');
    }
  };

  const handleRightClick = () => {
    if (stage === STAGES.initial) {
      setStage(STAGES.wrong_question);
    } else if (stage === STAGES.wrong_question) {
      setStage(STAGES.discuss_later);
    } else if (stage === STAGES.discuss_later) {
      setStage(STAGES.so_youKnow);
    } else if (stage === STAGES.so_youKnow) {
      setStage(STAGES.like_you);
    } else if (stage === STAGES.like_you) {
      setStage(STAGES.my_valentine);
      setNoValentineOpacity(1);
      setNoValentineNoIsQuestion(false);
      setNoButtonFalling(false);
        setHansumBirdJumping(false);
        setShowHamiltonDance(false);
        setShowReiSayYes(false);
      setYesButtonHovered(false);
      setYesValentineScale(1);
    } else if (stage === STAGES.my_valentine) {
      if (noValentineNoIsQuestion) {
        setHansumBirdJumping(true);
      } else if (noImgIndex >= NO_IMGS.length - 1) {
        setNoButtonSpinning(true);
      } else {
        setNoImgIndex((i) => (i < NO_IMGS.length - 1 ? i + 1 : i));
        setYesValentineScale((s) => Math.min(3, s * 1.2));
      }
    }
  };

  const leftLabel =
    stage === STAGES.initial
      ? 'Yes'
      : stage === STAGES.wrong_question
        ? 'Yup'
        : stage === STAGES.discuss_later
          ? 'Fine...' 
          : stage === STAGES.so_youKnow 
            ? 'Yeah...'
            : stage === STAGES.like_you
              ? "I know, who wouldn't"
              : "Yes";

  const noButtonHoverActive =
    stage === STAGES.my_valentine && noImgIndex >= NO_IMGS.length - 1;
    
  const noButtonOpacity =
    stage === STAGES.my_valentine
      ? noButtonHoverActive && noValentineHovered
        ? 1
        : noButtonHoverActive
          ? 1
          : noValentineOpacity
      : undefined;

  const rightLabel =
    stage === STAGES.my_valentine && noValentineNoIsQuestion
      ? '???'
      : stage === STAGES.initial
        ? 'No!'
        : stage === STAGES.wrong_question
          ? 'Well, not necessarily...'
          : stage === STAGES.discuss_later
            ? 'But-'
            : stage === STAGES.so_youKnow
              ? "I don't actually"
              : stage === STAGES.like_you
                ? 'WHAT?! WHAAA??'
                : 'No';

  return (
    <div className="dashboard q9__dashboard">
    <header className="dashboard__header">
      <div>
        <span className="dashboard__label">I'm a hexgates title</span>
        <h1>Project Valen</h1>
        <p>So... hum...</p>
      </div>
      <div className="dashboard__stats home__stats">
        <div className="dashboard__stat">
          <span className="dashboard__stat-label">Challenge</span>
          <span className="dashboard__stat-value">{questionDisplay} / ?</span>
        </div>
      </div>
    </header>
    <div className="home__center q2__center q9__center">
      <span className="secretpin__title q12__greeting">{greeting}</span>
      <div className="q9__buttons">
        <button
          type="button"
          className="dashboard__button dashboard__button--primary home__button q12__wave-button"
          onClick={handleLeftClick}
          onMouseEnter={
            stage === STAGES.my_valentine && noValentineNoIsQuestion && showReiSayYes
              ? () => setYesButtonHovered(true)
              : undefined
          }
          onMouseLeave={
            stage === STAGES.my_valentine && noValentineNoIsQuestion && showReiSayYes
              ? () => setYesButtonHovered(false)
              : undefined
          }
          style={stage === STAGES.my_valentine ? { transform: `scale(${displayYesScale})` } : undefined}
        >
          {leftLabel}
        </button>
        {stage === STAGES.my_valentine && noValentineNoIsQuestion ? (
          <div className={`q12__no-button-wrapper${noButtonFalling ? ' q12__no-button-wrapper--falling' : ''}`}>
            {(hansumBirdJumping || noButtonFalling) && (
              <img
                src={hansumBird}
                alt=""
                className={`q12__bird-on-button${hansumBirdJumping ? ' q12__bird-on-button--jumping' : ' q12__bird-on-button--falling'}`}
                onAnimationEnd={
                  hansumBirdJumping
                    ? () => {
                        setHansumBirdJumping(false);
                        setNoButtonFalling(true);
                        setShowHamiltonDance(true);
                      }
                    : undefined
                }
              />
            )}
            <button
              type="button"
              className={`dashboard__button dashboard__button--primary home__button q12__wave-button q12__slot-button${noButtonSpinning ? ' q12__no-button--spin' : ''}${noButtonFalling ? ' q12__no-button--falling' : ''}${hansumBirdJumping ? ' q12__no-button--hidden' : ''}`}
              onClick={handleRightClick}
              onAnimationEnd={() => {
                if (noButtonSpinning) {
                  setNoButtonSpinning(false);
                  setNoValentineNoIsQuestion(true);
                }
              }}
              onMouseEnter={noButtonHoverActive ? () => setNoValentineHovered(true) : undefined}
              onMouseLeave={noButtonHoverActive ? () => setNoValentineHovered(false) : undefined}
              style={noButtonOpacity !== undefined ? { opacity: noButtonOpacity } : undefined}
            >
              {rightLabel}
            </button>
          </div>
        ) : (
          <button
            type="button"
            className={`dashboard__button dashboard__button--primary home__button q12__wave-button${noButtonSpinning ? ' q12__no-button--spin' : ''}`}
            onClick={handleRightClick}
            onAnimationEnd={() => {
              if (noButtonSpinning) {
                setNoButtonSpinning(false);
                setNoValentineNoIsQuestion(true);
              }
            }}
            onMouseEnter={noButtonHoverActive ? () => setNoValentineHovered(true) : undefined}
            onMouseLeave={noButtonHoverActive ? () => setNoValentineHovered(false) : undefined}
            style={noButtonOpacity !== undefined ? { opacity: noButtonOpacity } : undefined}
          >
            {rightLabel}
          </button>
        )}
      </div>
      <img
        src={gifSrc}
        alt=""
        className={`q12__gif${gifSrc === reiBlush ? ' q12__gif--small' : ''}${gifSrc === hansumBird ? ' q12__gif--bird' : ''}${gifSrc === hamiltonKingDance ? ' q12__gif--hamilton' : ''}${gifSrc === reiSayYes ? ' q12__gif--rei-say-yes' : ''}`}
      />
    </div>
  </div>
  );
}

export default Q12;
